import _mixin from '../_mixin'
const img1 = 'https://rescdn.ssjj.cn/website/2025/08/13/4df33483da52e668376662845aebdf3c.png'
const img1Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/4df33483da52e668376662845aebdf3c.png'
const img2 = 'https://rescdn.ssjj.cn/website/2025/08/13/df9052662e6ccd10abbbedbfbe4efed5.png'
const img2Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/df9052662e6ccd10abbbedbfbe4efed5.png'
const img3 = 'https://rescdn.ssjj.cn/website/2025/08/13/3980d4325c5693671a0d829e9bd22e25.png'
const img3Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/3980d4325c5693671a0d829e9bd22e25.png'
const img4 = 'https://rescdn.ssjj.cn/website/2025/08/13/9729f625ab89c5783c11223817b83b57.png'
const img4Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/9729f625ab89c5783c11223817b83b57.png'
const img5 = 'https://rescdn.ssjj.cn/website/2025/08/13/776672e6218e6601c52014e470c317e0.png'
const img5Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/776672e6218e6601c52014e470c317e0.png'
const img6 = 'https://rescdn.ssjj.cn/website/2025/08/13/ed6d0ca7ad24fcbe82e9f4dd72892716.png'
const img6Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/ed6d0ca7ad24fcbe82e9f4dd72892716.png'
const img7 = 'https://rescdn.ssjj.cn/website/2025/08/13/fbcb3c9125f93f66615620137393b84f.png'
const img7Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/fbcb3c9125f93f66615620137393b84f.png'
const img8 = 'https://rescdn.ssjj.cn/website/2025/08/13/279481a6c4be66eb0012c870e31450ae.png'
const img8Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/279481a6c4be66eb0012c870e31450ae.png'
const img9 = 'https://rescdn.ssjj.cn/website/2025/08/13/1f4ba32995a8b67bc6687cb386776170.png'
const img9Hover = 'https://rescdn.ssjj.cn/website/2025/08/13/1f4ba32995a8b67bc6687cb386776170.png'
export default {
  name: 'SVersionAnchorNav',
  cnName: '右侧锚点导航',
  type: 'activity_version',
  // 属性相关
  props: {
    navBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2023/02/27/8a8377d387520a9a2a06c6e7d05d5c37.png',
      style: {
        width: '260px',
        height: '623px'
      }
    },
    navPadding: '0 0 0 0',
    list: [
      { targetId: 'BaseGroup_1753413403290', default: img1, active: img1Hover },
      { targetId: 'BaseGroup_1753422638436', default: img2, active: img2Hover },
      { targetId: 'BaseGroup_1753422915951', default: img3, active: img3Hover },
      { targetId: 'BaseGroup_1753425388414', default: img4, active: img4Hover },
      { targetId: 'BaseGroup_1753425664280', default: img5, active: img5Hover },
      { targetId: 'BaseGroup_1753425864322', default: img6, active: img6Hover },
      { targetId: 'BaseGroup_1753426983900', default: img7, active: img7Hover },
      { targetId: 'BaseGroup_1753427234509', default: img8, active: img8Hover },
      { targetId: 'BaseGroup_1753427548296', default: img9, active: img9Hover }
    ],
    itemSize: '260px 70px',
    itemMargin: '0 0 20px 0',
    backTopImg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2023/02/27/8a8377d387520a9a2a06c6e7d05d5c37.png',
      style: {
        width: '260px',
        height: '70px',
        top: '0',
        left: '0'
      }
    }
  },
  propsDesc: [
    {
      target: 'navBg',
      label: '导航背景',
      formType: 'image'
    },
    {
      target: 'navPadding',
      label: '导航内边距'
    },
    {
      target: 'list',
      label: '锚点列表',
      formType: 'list',
      listConfig: [
        {
          title: '锚点ID',
          target: 'targetId'
        },
        {
          title: '默认图',
          target: 'default'
        },
        {
          title: '选中图',
          target: 'active'
        }
      ]
    },
    {
      target: 'itemSize',
      label: 'item尺寸',
      formType: 'size'
    },
    {
      target: 'itemMargin',
      label: 'item间距'
    },
    {
      target: 'backTopImg',
      label: '返回顶部按钮',
      formType: 'image'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles,
    position: 'fixed',
    right: '0',
    top: '300px',
    height: 'auto',
    'z-index': '999'
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: []
}
